import React from "react";
import { Shield, Database, Share2, Lock, UserCheck, FileText } from "lucide-react";

const politicaDePrivacidad = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-16 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header empresarial */}
        <div className="bg-white border border-gray-200 rounded-lg mb-8 p-8">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-lg" style={{ backgroundColor: "#f0fdf4" }}>
                <Shield className="h-6 w-6" style={{ color: "#77c593" }} />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Política de Privacidad y Protección de Datos</h1>
                <p className="text-gray-600 mt-1">Mayma</p>
              </div>
            </div>
          </div>
        </div>

        {/* Contenido principal */}
        <div className="bg-white border border-gray-200 rounded-lg">
          <div className="p-8">
            {/* Sección 1 */}
            <section className="mb-8">
              <div className="flex items-center gap-3 mb-4 pb-2 border-b border-gray-100">
                <Database className="h-5 w-5 text-gray-600" />
                <h2 className="text-lg font-semibold text-gray-900">1. Recopilación de Información</h2>
              </div>
              <div className="ml-8 space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  En el marco de la prestación de nuestros servicios, recopilamos únicamente los datos estrictamente
                  necesarios para el funcionamiento del sistema:
                </p>

                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <h4 className="font-medium text-gray-900 mb-3">Datos Recopilados:</h4>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start gap-2">
                      <div
                        className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0"
                        style={{ backgroundColor: "#77c593" }}
                      ></div>
                      <span>
                        <strong>Información de contacto:</strong> Nombre completo del cliente
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div
                        className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0"
                        style={{ backgroundColor: "#77c593" }}
                      ></div>
                      <span>
                        <strong>Datos de comunicación:</strong> Número de teléfono para WhatsApp
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div
                        className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0"
                        style={{ backgroundColor: "#77c593" }}
                      ></div>
                      <span>
                        <strong>Información operativa:</strong> Datos relacionados con las solicitudes de servicio
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Sección 2 */}
            <section className="mb-8">
              <div className="flex items-center gap-3 mb-4 pb-2 border-b border-gray-100">
                <UserCheck className="h-5 w-5 text-gray-600" />
                <h2 className="text-lg font-semibold text-gray-900">2. Finalidad del Tratamiento</h2>
              </div>
              <div className="ml-8 space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  Los datos personales recopilados son utilizados exclusivamente para las siguientes finalidades:
                </p>

                <div className="grid gap-4">
                  <div className="border border-gray-200 rounded-lg p-4">
                    <h4 className="font-medium text-gray-900 mb-2">Prestación del Servicio</h4>
                    <p className="text-gray-700 text-sm">Envío de notificaciones automatizadas a través de WhatsApp</p>
                  </div>
                  <div className="border border-gray-200 rounded-lg p-4">
                    <h4 className="font-medium text-gray-900 mb-2">Mejora Continua</h4>
                    <p className="text-gray-700 text-sm">
                      Optimización de la experiencia del usuario y calidad del servicio
                    </p>
                  </div>
                  <div className="border border-gray-200 rounded-lg p-4">
                    <h4 className="font-medium text-gray-900 mb-2">Soporte Técnico</h4>
                    <p className="text-gray-700 text-sm">
                      Asistencia técnica y resolución de incidencias cuando sea necesario
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Sección 3 */}
            <section className="mb-8">
              <div className="flex items-center gap-3 mb-4 pb-2 border-b border-gray-100">
                <Share2 className="h-5 w-5 text-gray-600" />
                <h2 className="text-lg font-semibold text-gray-900">3. Compartición de Datos con Terceros</h2>
              </div>
              <div className="ml-8 space-y-4">
                <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                  <p className="text-gray-800 font-medium">Compromiso de Confidencialidad</p>
                  <p className="text-gray-700 mt-2 leading-relaxed">
                    No compartimos, vendemos, alquilamos ni transferimos información personal a terceros, salvo en los
                    casos estrictamente requeridos por obligación legal o autoridad competente.
                  </p>
                </div>
              </div>
            </section>

            {/* Sección 4 */}
            <section className="mb-8">
              <div className="flex items-center gap-3 mb-4 pb-2 border-b border-gray-100">
                <Lock className="h-5 w-5 text-gray-600" />
                <h2 className="text-lg font-semibold text-gray-900">4. Seguridad y Protección de Datos</h2>
              </div>
              <div className="ml-8 space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  Implementamos medidas técnicas y organizativas apropiadas para garantizar la seguridad de los datos
                  personales:
                </p>
                <ul className="text-gray-700 space-y-2 ml-4">
                  <li>• Cifrado de datos en tránsito y en reposo</li>
                  <li>• Controles de acceso y autenticación</li>
                  <li>• Monitoreo continuo de seguridad</li>
                  <li>• Copias de seguridad regulares</li>
                </ul>
              </div>
            </section>

            {/* Sección 5 */}
            <section className="mb-8">
              <div className="flex items-center gap-3 mb-4 pb-2 border-b border-gray-100">
                <FileText className="h-5 w-5 text-gray-600" />
                <h2 className="text-lg font-semibold text-gray-900">5. Derechos del Titular de los Datos</h2>
              </div>
              <div className="ml-8 space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  Como titular de los datos, usted tiene los siguientes derechos:
                </p>

                <div className="grid md:grid-cols-2 gap-4">
                  <div className="border border-gray-200 rounded-lg p-3">
                    <h4 className="font-medium text-gray-900 text-sm">Derecho de Acceso</h4>
                    <p className="text-gray-600 text-xs mt-1">Conocer qué datos tenemos sobre usted</p>
                  </div>
                  <div className="border border-gray-200 rounded-lg p-3">
                    <h4 className="font-medium text-gray-900 text-sm">Derecho de Rectificación</h4>
                    <p className="text-gray-600 text-xs mt-1">Corregir datos inexactos o incompletos</p>
                  </div>
                  <div className="border border-gray-200 rounded-lg p-3">
                    <h4 className="font-medium text-gray-900 text-sm">Derecho de Supresión</h4>
                    <p className="text-gray-600 text-xs mt-1">Solicitar la eliminación de sus datos</p>
                  </div>
                  <div className="border border-gray-200 rounded-lg p-3">
                    <h4 className="font-medium text-gray-900 text-sm">Derecho de Oposición</h4>
                    <p className="text-gray-600 text-xs mt-1">Retirar el consentimiento otorgado</p>
                  </div>
                </div>

                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mt-4">
                  <p className="text-gray-700">
                    <strong>Para ejercer estos derechos, contáctenos en:</strong>{" "}
                    <a
                      href="mailto:maymasistemas@gmail.com"
                      className="font-medium hover:underline transition-colors"
                      style={{ color: "#77c593" }}
                    >
                      maymasistemas@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </section>
          </div>

          {/* Footer del documento */}
          <div className="border-t border-gray-200 bg-gray-50 px-8 py-4">
            <div className="flex justify-between items-center text-sm text-gray-600">
              <p>© {new Date().getFullYear()} Mayma. Todos los derechos reservados.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default politicaDePrivacidad;
